import React from 'react';
import store from '../store';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import jwt_decode from 'jwt-decode';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { SelectPicker } from 'rsuite';
import { setCurrentOrg } from '../actions/authentication';
import { listOrganizations } from '../actions/organization';
import { listClients } from '../actions/client';


class OrganizationSwitch extends React.Component {
  constructor() {
      super();
      this.state = {
          orgcurrent: '',
          errors: {},
      };
      this.handleOrganizationSelect = this.handleOrganizationSelect.bind(this);

  }

  componentDidMount() {
    this.props.listOrganizations();
    this.setState({currentorg: this.props.orgcurrent.list});
    const currentorg = this.props.orgcurrent.list;
    if(localStorage.jwtToken) {
      const decoded = jwt_decode(localStorage.jwtToken);
      if (!currentorg || currentorg === '' || currentorg === undefined || currentorg.length === 0) {
        this.props.setCurrentOrg(decoded.organizations[0]);
      } else if (currentorg.length > 4) {
        this.setState({orgcurrent: currentorg});
      // this.props.setCurrentOrg(currentorg);
      }
    }

  }

  componentDidUpdate(prevProps) {
    if ( this.props.orgcurrent.list !== prevProps.orgcurrent.list ) {
      let og = this.props.orgcurrent.list;
      this.setState({orgcurrent: og});
    }
}

  handleOrganizationSelect(e) {
    this.props.setCurrentOrg(e);
  }

  render() {
    const { errors } = this.state;
    let orglist = this.props.organizations.list;
    let orgcurent = this.state.orgcurrent;
    let orgsel = [];
    for (var i = 0; i < orglist.length; i++) {
      const l = orglist[i].name;
      const v = orglist[i]._id;
      orgsel.push({ label: l, value: v });
    }
    return (
        <div className="organization-switch">
            <SelectPicker
            cleanable={false}
            value={orgcurent}
            data={orgsel} style={{ width: 224 }}
            onChange={this.handleOrganizationSelect}

            />
        </div>
    );
  }
  }

  OrganizationSwitch.propTypes = {
      listClients: PropTypes.func.isRequired,
      listOrganizations: PropTypes.func.isRequired,
      setCurrentOrg: PropTypes.func.isRequired,
  };

  const mapStateToProps = state => ({
      clients: state.clients,
      organizations: state.organizations,
      orgcurrent: state.orgcurrent,
      auth: state.auth,
      errors: state.errors
  });

  export default connect(mapStateToProps,{listClients, listOrganizations, setCurrentOrg })(withRouter(OrganizationSwitch))
